export default "__VITE_ASSET__c3b9b660__"